/* eslint-disable jira/filename-case */
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
export const getBundlerVersion = (): any => window.BUNDLER_VERSION; // oxlint-disable-line @typescript-eslint/no-explicit-any
